module.exports = __webpack_public_path__ + "logo-orkla-tagline-fi-bf573a645f6dcf54f9105cd87f399985.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-fi.png
// module id = 66
// module chunks = 0